import http from "@/apps/shared/baseService/config";

const base = {
  rota: "student",
  nome: "Aluno"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_students: ({ commit, dispatch, getters }) => {
      if (localStorage.getItem("students")) {
        commit("set_students", JSON.parse(localStorage.getItem("students")));
      } else {
        dispatch("enableLoading");
      }
      service
        .listar(getters.get_students_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("students", JSON.stringify(res.data));
          commit("set_students", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_student: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({ ...getters.get_student, imagens: getters.getLinks })
        .then(res => {
          dispatch("disableLoading");
          commit("set_student", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_students");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_student: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_student, imagens: getters.getLinks })
        .then(() => {
          dispatch("disableLoading");
          commit("set_student", {});
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_students");
          commit("set_modal_view_student", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_student: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_students");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_student: ({ commit }, payload) => {
      if (payload) {
        commit("set_student", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_student", true);
    },
    fecha_modal_view_student: ({ commit }) => {
      commit("set_student", {});
      commit("setLinks", []);
      commit("set_modal_view_student", false);
    }
  },
  state: {
    student: {},
    students: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    students_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_student: false
  },
  mutations: {
    set_student: (state, payload) => (state.student = payload),
    set_students: (state, payload) => (state.students = payload),
    set_modal_view_student: (state, payload) =>
      (state.modal_view_student = payload)
  },
  getters: {
    get_student: state => state.student,
    get_students: state => state.students,
    get_modal_view_student: state => state.modal_view_student,
    get_students_filtros: state => state.students_filtros
  }
};

const routes = [
  {
    path: `/alunos`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
